import HealthPrismLogo from '../../../../src/icons/HealthPrism.png'
import PeoplePrismLogo from '../../../../src/icons/PeoplePrism.svg'
import {StyledAppBar, StyledDiv, StyledDivLogo} from './PanelHeaderStyle'
import DeloitteLogo from '../../../../src/icons/deloitte-logo-black.svg'
import CustomBox from '../CustomBox'
import Toolbar from '@mui/material/Toolbar'
import {Divider} from '@mui/material'
import {useCustomDashboardViewProvider} from '../../../store/hooks/customDashboardView'
import UserFeedbackDashboard from '../../Dashboard/UserFeedback/UserFeedbackDashboard'
import {usePermission} from '../../../store/hooks/permission'

const PanelHeader = () => {
  const {permission} = usePermission()
  const {prismProgram} = useCustomDashboardViewProvider()

  const isUserfeedbackAllowed = permission?.healthEquityConditionList?.userfeedbackFlagPermissions?.[0] === 1
  if (permission) localStorage.setItem('isUserfeedbackAllowed', isUserfeedbackAllowed)

  return (
    <StyledAppBar position='fixed'>
      <Toolbar style={{minHeight: '40px'}}>
        <CustomBox flexGrow={1} display='flex' alignItems='center'>
          <StyledDiv>
            <img height='13px' src={DeloitteLogo} alt='Deloitte Logo' />
          </StyledDiv>
          <Divider orientation='vertical' variant='fullWidth' flexItem height='46px' />
          {prismProgram === 'PeoplePrism' ? (
            <StyledDivLogo>
              <img height='17px' src={PeoplePrismLogo} alt='PeoplePrism Logo' />
            </StyledDivLogo>
          ) : (
            <StyledDiv>
              <img height='13px' src={HealthPrismLogo} alt='HealthPrism Logo' />
            </StyledDiv>
          )}
        </CustomBox>
        {isUserfeedbackAllowed && <UserFeedbackDashboard />}
      </Toolbar>
    </StyledAppBar>
  )
}
export default PanelHeader
